import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Communication } from './communication.interface';
import { CommunicationService } from './communication.service';
import messages, { MessageState } from './messages/message.store';
import whatsapp, { WhatsappState } from './whatsapp/whatsapp.store';
import { BulkWhatsappMessage } from './whatsapp/whatsapp.interface';

const service = new CommunicationService();

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CommunicationState {
   //modules
   messages?: MessageState;
   whatsapp?: WhatsappState;
}

const CommunicationStore: Module<CommunicationState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async createCommunication(context, communication: Communication) {
         const response = await service.postCommunication(communication);
         return response.data;
      },
      async changeCommunication(
         context,
         { communicationId, communication }: { communicationId: number; communication: { [key: string]: any } },
      ) {
         const response = await service.patchCommunication(communicationId, communication);
         return response.data;
      },
      async sendSms(context, communication: BulkWhatsappMessage) {
         const response = await service.sendSms(communication);
         return response;
      },
      async sendWhatsapp(context, communication: BulkWhatsappMessage) {
         const response = await service.sendWhatsapp(communication);
         return response;
      },
   },
   modules: {
      messages,
      whatsapp,
   },
};

export default CommunicationStore;
